import axios from 'axios';
import AxiosError from 'axios-error';
import * as actionTypes from './action-types';
import { WpDpApi, DpServerApi } from '../../axios-configs';
import { ProcessState, AppState } from '../appMode';
import { getChangesCount } from '../utility';

const i18n = window.dpIntroTourPublicConfig.i18n;


export const saveChanges = (tourId, stepChanges, triggerChanges, mobileMenuChanges, urlVarExamplesChanges, stepAddedRemovedHist, onSuccess, onError) => {
	const totalChanges = getChangesCount(stepChanges) + getChangesCount(triggerChanges) + getChangesCount(mobileMenuChanges) + getChangesCount(urlVarExamplesChanges) + stepAddedRemovedHist.length;
	const data = {
		stepChanges,
		triggerChanges,
		mobileMenuChanges,
		urlVarExamplesChanges,
		stepAddedRemovedHist,
		tourId,
	};
	return (dispatch) => {

		dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'savingState', processState: ProcessState.PROCESSING });
		dispatch({ type: actionTypes.CLEAR_ALL_CHANGES });
		axios.post('/save-changes', data, WpDpApi)
			.then(() => {
				dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'savingState', processState: ProcessState.PROCESSED });
				dispatch({ type: actionTypes.SET_TOTAL_SAVED_CHANGES, totalSavedChanges: totalChanges, increment: true });
				try {

					setTimeout(() => {
						if (onSuccess) onSuccess();
						setTimeout(() => {
							dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'savingState', processState: ProcessState.IDLE });
						}, 2000);
					}, 100);
				} catch (error) {
					dispatch({
						type: actionTypes.SET_PROCESS_STATE, stateName: 'savingState', processState: ProcessState.ERROR, error: i18n.saving_err_2, errorDetail: error.toString(),
					});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type: actionTypes.RESTORE_ALL_CHANGES });
				dispatch({ type: actionTypes.SET_APP_STATE, appState: AppState.VIEW });
				dispatch({
					type: actionTypes.SET_PROCESS_STATE, stateName: 'savingState', processState: ProcessState.ERROR, error: i18n.saving_err_1, errorDetail: new AxiosError(error).toString(),
				});
				if (onError) onError();
				setTimeout(() => {
					dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'savingState', processState: ProcessState.IDLE });
				}, 4000);
			});

	};
};

export const isUrlValid = (url, onSuccess, onError) => (dispatch) => {
	dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'apiReqState', processState: ProcessState.PROCESSING });
	axios.get(`/get-compatible-post?url=${url}`, WpDpApi)
		.then((response) => {
			dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'apiReqState', processState: ProcessState.PROCESSED });
			try {
				if (onSuccess) onSuccess(response.data);
				setTimeout(() => {
					dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'apiReqState', processState: ProcessState.IDLE });
				}, 2000);
			} catch (error) {
				dispatch({
					type: actionTypes.SET_PROCESS_STATE, stateName: 'apiReqState', processState: ProcessState.ERROR, error: i18n.url_validation_cbk_failed, errorDetail: error.toString(),
				});
			}
		})
		.catch((error) => {
			console.log(error);
			dispatch({
				type: actionTypes.SET_PROCESS_STATE, stateName: 'apiReqState', processState: ProcessState.ERROR, error: i18n.url_validation_failed, errorDetail: new AxiosError(error).toString(),
			});
			if (onError) onError();
			setTimeout(() => {
				dispatch({ type: actionTypes.SET_PROCESS_STATE, stateName: 'apiReqState', processState: ProcessState.IDLE });
			}, 4000);
		});
};

export const sendAskForRatingFeedbackToDP = (type, onSuccess, onError) => () => {
	axios.post(`/${type}`, {}, DpServerApi)
		.then((response) => {
			if (onSuccess) onSuccess(response.data);
		})
		.catch((error) => {
			if (onError) onError();
			console.log(new AxiosError(error));
		});
};

export const deleteTourPost = (tourId, forceDelete, onSuccess, onError) => () => {
	const data = {
		tourId: tourId,
		forceDelete: forceDelete
	};
	axios.post('/delete-tour', data, WpDpApi)
		.then((response) => {
			if (onSuccess) onSuccess(response.data);
		})
		.catch((error) => {
			if (onError) onError();
			console.log(new AxiosError(error));
		});
};
